<template>
    <div class="container">
        <div class="category-list">
            {{ waitingList }}
            <app-category
                v-for="category in categories_list"
                :category="category"
                :key="category.id"
            ></app-category>

        </div>
    </div>
</template>

<script>
    import AppCategory from "./Category";

    export default {
        props: ['categories_list', 'waitingList'],

        data () {
            return {
                errored: false,
            }
        },

        components: {
            AppCategory
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/app/pages/order/CategoryList.vue